import axios from 'axios';
const getInternalNotes = id =>
  axios.get(`/internal_notes/get_internal_notes?company_id=${id}`);
const createNote = ({ companyId, title, text, clientNote }) =>
  axios.post('/internal_notes/create_note', {
    title,
    text,
    company_id: companyId,
    client_note: clientNote,
  });
const deleteNote = id => axios.delete(`/internal_notes/${id}`);

export default {
  getInternalNotes,
  createNote,
  deleteNote,
};
